import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import i18n from 'i18n';
import BackButton from 'components/BackButton';
import Button from 'components/Button';
import List from 'components/List';
import withScrollHack from 'components/HOCs/withScrollHack';
import {
  StyledActions,
  StyledListWrapper,
  StyledPackageDescription,
  StyledPackagePrice,
  StyledPackageTitle,
  StyledPageContent,
  StyledPageLayout,
} from './StyledComponents';

const listConfig = {
  leaveFor: {
    right: '',
    left: '@BACK_BUTTON',
  },
};

const PackagePage = (props) => {
  const history = useHistory();
  const { data, extraData, isLoggedIn, handleChange } = props;
  const { name, description, cost, unit, isAdditional: isAdditionalPkg } = data || {};

  const [pageOffset, setPageOffset] = useState(0);
  const resetPageOffset = useCallback(() => setPageOffset(0), []);

  const handleListItemFocus = useCallback(
    (_, listOffset) => {
      // Temporary removed padding cause of LG bug [LGERPSTE-17233] Some content overlays the other
      // const padding = scaleSize(-100);

      const newOffset = -listOffset; // + padding;
      if (pageOffset !== newOffset) {
        setPageOffset(newOffset);
      }
    },
    [pageOffset],
  );

  useEffect(() => {
    if (!data) history.goBack();
  }, [data, history]);

  if (!data) return null;

  return (
    <StyledPageLayout>
      <BackButton
        navigationConfig={{
          leaveFor: {
            right: '@ACTION_BUTTONS',
            up: '',
            left: '',
            down: '@ACTION_BUTTONS',
          },
        }}
        onEnter={history.goBack}
      />
      <StyledPageContent pageOffset={pageOffset}>
        <StyledPackageTitle>{name}</StyledPackageTitle>
        <StyledPackageDescription>{description}</StyledPackageDescription>
        <StyledActions
          sectionName={'ACTION_BUTTONS'}
          config={{
            leaveFor: {
              right: '',
            },
          }}
          defaultSection
        >
          <Button onFocus={resetPageOffset} onEnter={handleChange} focusOnMouseEnter>
            {isAdditionalPkg || !isLoggedIn ? i18n.t(`packages.activate`) : i18n.t(`packages.change`)}
          </Button>
          <StyledPackagePrice>
            {cost} {unit}
          </StyledPackagePrice>
        </StyledActions>
        {extraData.map((props, idx) => (
          <StyledListWrapper key={idx}>
            <List
              key={props.listId}
              config={listConfig}
              onListItemFocus={handleListItemFocus}
              extraPadding={275}
              {...props}
            />
          </StyledListWrapper>
        ))}
      </StyledPageContent>
    </StyledPageLayout>
  );
};

export default withScrollHack(PackagePage);
